export default {
  webhook: {
    name: 'String',
    url: 'String',
    events: 'Array',
    filters: {
      key: 'value',
    },
    excludeBody: 'Boolean',
  },
}
